import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { EntiteModel } from 'src/app/models/entites/entite.model';
import { EntitesService } from 'src/app/services/entites/entites.service';

export const utilisateurEntitesResolver: ResolveFn<EntiteModel[]> =
  (): Observable<EntiteModel[]> => {
    const entitesService = inject(EntitesService);
    return entitesService.getUtilisateursEntitesGerables();
  };
